module.exports = __webpack_public_path__ + "static/media/Surface604Logo.fb614b79.avif";